<template>
  <div>
    <div class="row">
      <template v-if="$operatorRetail() == 2">
        <div class="col-lg-4">
          <v-card elevation="2">
            <v-card-title>
              <div>{{ $t("currentBalance") }}</div>
            </v-card-title>
            <v-card-text>
              <div>
                <v-icon>mdi-currency-usd</v-icon>
                {{ balance }}
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="col-lg-4">
          <v-card elevation="2">
            <v-card-title>
              <div>{{ $t("limitSales") }}</div>
            </v-card-title>
            <v-card-text>
              <div>
                <v-icon>mdi-currency-usd</v-icon>
                {{ limit_retention | maskValue }}
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="col-lg-4">
          <v-card elevation="2">
            <v-card-title>
              <div>{{ $t("remainingBalance") }}</div>
            </v-card-title>
            <v-card-text>
              <div>
                <v-icon>mdi-currency-usd</v-icon>
                {{ remaining_balance | maskValue }}
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>

      <div v-if="affiliateLevel != 1" class="col-lg-6">
        <v-card color="grey darken-4">
          <v-toolbar dense elevation="0">
            <v-toolbar-title>{{ $t("weeekSales") }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <LineChart
            :data="dataLineChart.data"
            :labels="dataLineChart.labels"
            :max="maxLineChart"
          />
        </v-card>
      </div>

      <div v-if="affiliateLevel != 1" class="col-lg-6">
        <v-card color="grey darken-4">
          <v-toolbar dense elevation="0">
            <v-toolbar-title>{{ $t("topClients") }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <BarChart
            :data="dataBarChart.data"
            :labels="dataBarChart.labels"
            :max="maxBarChart"
          />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/agent/Backoffice/Charts/BarChart";
import LineChart from "@/components/agent/Backoffice/Charts/LineChart";

export default {
  name: "Home-Dashboard",
  components: {
    BarChart,
    LineChart,
  },
  data: () => ({
    balance: "",
    limit_retention: "",
    remaining_balance: "",
    maxLineChart: null,
    dataLineChart: {
      data: [],
      labels: [],
    },
    maxBarChart: null,
    dataBarChart: {
      data: [],
      labels: [],
    },
  }),
  computed: {
    // affiliateStatus:
    // 0 == agent;
    // 1 == affiliate(ex.: influencer);
    // 2 == agent && Affiliate

    // Até o momento, do que foi passado:
    // 0 == não oculta menus nem tab 'validar', 1 == oculta menus e tab 'validar' e 2 == não oculta menus nem tab 'validar'
    affiliateLevel() {
      return this.$store.state.logged.data.is_afilliate;
    },
    weekName() {
      return {
        Monday: this.$t("monday"),
        Tuesday: this.$t("tuesday"),
        Wednesday: this.$t("wednesday"),
        Thursday: this.$t("thursday"),
        Friday: this.$t("friday"),
        Saturday: this.$t("saturday"),
        Sunday: this.$t("sunday"),
      };
    },
  },
  mounted() {
    this.getDataCharts();
  },
  methods: {
    getDataCharts() {
      this.$axios.post("agent/dashboard/graphic").then((resp) => {
        const {
          dados,
          topBetsPunter,
          balance,
          limit_retention,
          remaining_balance,
        } = resp.data;

        this.balance = balance;
        this.limit_retention = limit_retention;
        this.remaining_balance = remaining_balance;

        dados.map((item) => {
          this.dataLineChart.labels.push(this.weekName[item.dayname]);
          this.dataLineChart.data.push(item.bets_ammount);
        });
        this.maxLineChart = Math.max.apply(null, this.dataLineChart.data) + 120;

        topBetsPunter.map((item) => {
          this.dataBarChart.labels.push(item.apostador);
          this.dataBarChart.data.push(item.bets_ammount);
        });
        this.maxBarChart = Math.max.apply(null, this.dataBarChart.data) + 120;
      });
    },
  },

  filters: {
    maskValue: function(val) {
      return val >= 1000000 ? "Unlimited" : val;
    },
  },
};
</script>
